import * as e from "ramda";
const o = e.pipe(e.toLower, e.replace("_", "-")), p = e.pipe(e.toLower, e.replace("-", "_"));
export {
  o as hyphenLocale,
  p as underscoreLocale
};
//# sourceMappingURL=locale.js.map
